
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpEventType } from '@angular/common/http';
import * as SaleArticleModels from '../../models/sale-article/sale-article';
import { EnvironmentService } from '../../../app/services/environment.service';
import { SaleArticleSearchModel } from '../../models/sale-article/sale-articleSearch';
import { SpecificationListSummaryModel } from '../../models/specification/specification';

@Injectable({
  providedIn: 'root'
})

export class SaleArticleService {

constructor(private httpClient: HttpClient,
            private environmentService: EnvironmentService
            ) { }

  public get(Search: SaleArticleSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<SaleArticleModels.SaleArticleListModel>(`${this.environmentService.getApiURL()}/sale/article/list`, Search, options);
  }

  public getSummary(Search: SaleArticleSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<SpecificationListSummaryModel>(
      `${this.environmentService.getApiURL()}/sale/article/list/summary`, Search, options
      );
  }

  public getFilteredReport(Search: SaleArticleSearchModel) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders, responseType: 'blob' as 'json'};
    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/sale/article/report/filtered`, Search, options);

  }


}
